/* importação de módulos */

// @ts-ignore - import map resolve
import http from '@theme/http-service';

/* tipos */

/**
 * @typedef {CustomEvent<{pd: string}>} DnpResultEvent
 */

/* classe */

class MyDnp {

  /* campos privados */

  /**
   * @type {HTMLButtonElement | null}
   */
  #btn;

  /**
   * @type {HTMLDivElement | null}
   */
  #result;

  /**
   * @type {HTMLDivElement | null}
   */
  #resultMessage;

  /**
   * @type {HTMLDivElement | null}
   */
  #resultValue;

  /* constructor */

  constructor() {
    this.#btn = document.querySelector('.my-dnp__btn');
    this.#result = document.querySelector('.my-dnp__result');
    this.#resultMessage = document.querySelector('.my-dnp__result-message');
    this.#resultValue = document.querySelector('.my-dnp__result-value');

    this.#init();
  }

  /* métodos públicos */

  /* métodos privados */

  #init() {
    this.#btn?.addEventListener('click', this.#handleClick.bind(this));

    /** @type {any} */
    (window).pdMeter.init();
  }

  async #handleClick() {
    this.#disableButton();

    if (!await this.#tokenIsValid()) {
      this.#hideButton();
      this.#setResultMessage('Solicite um novo link!');
      return;
    }

    this.#enableButton();

    const initialized = await /** @type {any} */ (window).pdMeter.initialize();
    if (!initialized) {
      return;
    }

    const success = /** @type {any} */ (window).pdMeter.openPdMeter();
    if (!success) {
      return;
    }

    document.addEventListener('pdmeter:result', (/** @type {DnpResultEvent} */ event) => {
      this.#handleDnpResult(event);
    });
  }

  async #tokenIsValid() {
    const query = new URLSearchParams(window.location.search);
        
    const token = query?.get('token');
    const env = query?.get('env');

    if (!token) return false;

    const baseUrl = env === 'dev' 
      ? 'https://api-dev.zerezes.net/shopify/api'
      : 'https://api.zerezes.net/shopify/api';

    const result = await http.promiseGet(`${baseUrl}/dnp-link/validation?token=${token}`);

    return result?.value?.isValid;
  }

  /**
   * @param {DnpResultEvent} event
   */
  #handleDnpResult(event) {
    this.#hideButton();

    const pdValue = +event.detail.pd;
    const dnpValue = pdValue / 2;
    const dnpFormatedValue = dnpValue.toFixed(2).replace('.', ',');

    this.#setResultMessage('O valor da sua DNP é:');
    this.#setResultValue(dnpFormatedValue);
  }

  #disableButton() {
    if (this.#btn) {
      this.#btn.innerText = 'Aguarde...';
      this.#btn.disabled = true;
    }
  }

  #enableButton() {
    if (this.#btn) {
      this.#btn.innerText = 'Obter DNP';
      this.#btn.disabled = false;
    }
  }

  #hideButton() {
    if (this.#btn) {
      this.#btn.classList.add('hidden');
    }
  }

  /**
   * @param {string} message
   */
  #setResultMessage = (message) => {
    if (this.#resultMessage) {
      this.#resultMessage.textContent = message;
    }
  };

  /**
   * @param {string} value
   */
  #setResultValue = (value) => {
    if (this.#resultValue) {
      this.#resultValue.textContent = value;
    }
  };

}

/* inicialização */

document.addEventListener('DOMContentLoaded', () => {
  new MyDnp();
});